/**
 * Hartcodierte Modul-Labels als Fallback. Seit 2026-06-12 ist die Primaer-Quelle
 * die Self-Registry per Backend-Endpoint `/api/portal/modules-registry` —
 * Modul-Container deklarieren ihren Namen selbst, das Portal-Backend liefert
 * die Liste. Dieser Fallback greift nur wenn die Registry noch nicht migriert
 * ist oder ein Slug nicht enthalten ist.
 *
 * Komponenten sollten `useModuleRegistry()` bzw. `<ModuleRegistryProvider>`
 * nutzen, damit neue Module ohne Frontend-Re-Deploy in der UI auftauchen.
 */
const FALLBACK_LABEL: Record<string, string> = {
  bauberichteV2: 'Aufgaben & Berichte',
  plantafel: 'Plantafel',
  bibliothek: 'Bibliothek',
  stammdaten: 'Stammdaten',
  zeiterfassung: 'Zeiterfassung',
  assistant: 'Assistent',
  vorlagen: 'Vorlagen',
  'test-cockpit': 'Test-Cockpit',
  disposition: 'Auswertungen',
  chat: 'Chat',
};

// Re-Export fuer Backward-Compat. Neue Caller sollten useModuleRegistry() nutzen.
export const MODULE_LABEL = FALLBACK_LABEL;

let _liveLabels: Record<string, string> = { ...FALLBACK_LABEL };

/** Wird vom ModuleRegistryProvider gesetzt, sobald die Registry vom Backend geladen ist. */
export function setLiveModuleLabels(labels: Record<string, string>): void {
  _liveLabels = { ...FALLBACK_LABEL, ...labels };
}

export function getModuleLabel(slug: string): string {
  return _liveLabels[slug] ?? FALLBACK_LABEL[slug] ?? slug;
}
